import { Amplify } from 'aws-amplify';

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_52425',
      userPoolClientId: '634j4inn9uv8i0js7cgl8o28n2',
      region: 'us-east-1',
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
        oauth: {
          domain: 'tubeops-dev-52425.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [
            'https://tubeops.bestoai.com/auth/callback',
            'http://localhost:3005/auth/callback'
          ],
          redirectSignOut: [
            'https://tubeops.bestoai.com/auth/signin',
            'http://localhost:3005/auth/signin'
          ],
          responseType: 'code' as const,
          providers: ['Google' as const]
        }
      },
    }
  }
};

Amplify.configure(amplifyConfig);
export default amplifyConfig;
